import React from 'react';
import ContainerFlex from '~/components/containerFlex';
import TableOCR from '~/components/tableOCR';
import * as St from './OcrSection.styles';

interface OcrSectionProps {
  hasOCRData: boolean;
  loading: boolean;
  isFetched: boolean;
  error: boolean;
  data?: Array<{ title: string; value: string }>;
}

const OcrSection: React.FC<OcrSectionProps> = ({
  hasOCRData,
  loading,
  isFetched,
  error,
  data,
}) => {
  return (
    <ContainerFlex marginLeft={26} marginRight={26}>
      {hasOCRData ? (
        <TableOCR data={data} />
      ) : (isFetched || error) && !loading ? (
        <ContainerFlex center>
          <St.EmptyState>Não há dados de OCR para este cliente</St.EmptyState>
        </ContainerFlex>
      ) : null}
    </ContainerFlex>
  );
};

export default OcrSection;
